import { Link, useMatches } from "react-router";

type CleBreadcrumbItem = {
  label: string;
  to?: string;
};

type CleBreadcrumbHandle = {
  breadcrumbs?: CleBreadcrumbItem[];
};

const getBreadcrumbsFromHandle = (handle: unknown): CleBreadcrumbItem[] => {
  const breadcrumbHandle = handle as CleBreadcrumbHandle | undefined;

  return breadcrumbHandle?.breadcrumbs ?? [];
};

const CleBreadcrumbs = () => {
  const breadcrumbs = useMatches().flatMap((match) =>
    getBreadcrumbsFromHandle(match.handle),
  );

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav className="cle-breadcrumbs" aria-label="Brødkrumme">
      <ol className="cle-breadcrumbs__list">
        {breadcrumbs.map((breadcrumb, index) => {
          const isCurrent = index === breadcrumbs.length - 1;

          return (
            <li
              key={`${breadcrumb.label}-${index}`}
              className="cle-breadcrumbs__item"
            >
              {isCurrent || !breadcrumb.to ? (
                <span className="cle-breadcrumbs__current" aria-current="page">
                  {breadcrumb.label}
                </span>
              ) : (
                <Link className="cle-breadcrumbs__link" to={breadcrumb.to}>
                  {breadcrumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default CleBreadcrumbs;
